import { z } from "zod";

const translationPath = "chatBot.page.service.ticketFinishReason.errors.";

export const ticketFinishReasonSchema = z.object({
  id: z.string().optional(),
  enable: z.boolean(),
  name: z.string().min(1, translationPath + "name"),
});

export type TTicketFinishReasonForm = z.infer<typeof ticketFinishReasonSchema>;
